import PropTypes from 'prop-types';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core';
import OpenEndedAnswer from './openEndedAnswer';
import MultipleChoice from './multipleChoice';
import MultiSelect from './multiSelect';
import Ranking from './ranking';
import {
  QUESTIONNAIRE_QUESTION_TYPES,
  QUESTIONNAIRE_QUESTION_ANSWER_TYPES,
} from '../../../../constants/survey';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  rootHistory: {
    cursor: 'default',
  },
}));

const Answers = ({
  translations,
  question,
  subjects = [],
  results = {},
  answerReplyErrors = {},
  isPreview = false,
  isHistoryView = false,
  isSingleReview = false,
  onSetAnswerReplyErrors = () => {},
  onSelect = () => {},
  onChange = () => {},
  onDraftChange = () => {},
}) => {
  const classes = useStyles();
  const { id: questionId, type } = question;

  if (type === QUESTIONNAIRE_QUESTION_TYPES.OPEN_TEXT) {
    return (
      <div className={classes.root}>
        {subjects.map(subject => (
          <OpenEndedAnswer
            key={`answer_item_${subject.id}`}
            translations={translations}
            initialAnswer={
              results?.[subject.review_tracking]?.[questionId]?.[
                QUESTIONNAIRE_QUESTION_ANSWER_TYPES[type]
              ]
            }
            questionId={questionId}
            questionType={type}
            subject={subject}
            error={answerReplyErrors?.[subject.review_tracking]}
            isSingleReview={isSingleReview}
            isDisabled={isPreview}
            isHistoryView={isHistoryView}
            onSetError={onSetAnswerReplyErrors}
            onChange={onChange}
          />
        ))}
      </div>
    );
  }

  if (type === QUESTIONNAIRE_QUESTION_TYPES.SINGLE_SELECT) {
    return (
      <div
        className={classNames(classes.root, {
          [classes.rootHistory]: isHistoryView,
        })}
      >
        {question.options.map((option, index) => (
          <MultipleChoice
            key={`answer_item_${option.id ?? option.order ?? index}`}
            questionId={questionId}
            type={type}
            subjects={subjects}
            option={option}
            selection={results}
            isSingleReview={isSingleReview}
            isDisabled={isPreview}
            isHistoryView={isHistoryView}
            onSelect={onSelect}
          />
        ))}
      </div>
    );
  }

  if (type === QUESTIONNAIRE_QUESTION_TYPES.MULTI_SELECT) {
    return (
      <div
        className={classNames(classes.root, {
          [classes.rootHistory]: isHistoryView,
        })}
      >
        {question.options.map((option, index) => (
          <MultiSelect
            key={`answer_item_${option.id ?? option.order ?? index}`}
            questionId={questionId}
            type={type}
            subjects={subjects}
            option={option}
            selection={results}
            isSingleReview={isSingleReview}
            isHistoryView={isHistoryView}
            isDisabled={isPreview}
            onSelect={onSelect}
          />
        ))}
      </div>
    );
  }

  if (type === QUESTIONNAIRE_QUESTION_TYPES.RANKING) {
    return (
      <div className={classes.root}>
        {subjects.map(subject => (
          <Ranking
            key={`answer_item_${subject.id}`}
            translations={translations}
            questionId={questionId}
            questionType={type}
            subject={subject}
            options={question.options}
            rankedOptionIds={
              results?.[subject.review_tracking]?.[questionId]?.[
                QUESTIONNAIRE_QUESTION_ANSWER_TYPES[type]
              ]
            }
            isSingleReview={isSingleReview}
            isDisabled={isPreview}
            isHistoryView={isHistoryView}
            onChange={onChange}
            onDraftChange={onDraftChange}
          />
        ))}
      </div>
    );
  }

  return null;
};

Answers.propTypes = {
  translations: PropTypes.shape({}).isRequired,
  question: PropTypes.shape({}).isRequired,
  isSingleReview: PropTypes.bool,
  isPreview: PropTypes.bool,
  isHistoryView: PropTypes.bool,
  subjects: PropTypes.arrayOf(PropTypes.shape({})),
  results: PropTypes.shape({}),
  answerReplyErrors: PropTypes.shape({}),
  onSetAnswerReplyErrors: PropTypes.func,
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
  onDraftChange: PropTypes.func,
};

export default Answers;
